import axios from 'axios'

let baseURL = ''
const loc = window.location.host
if (loc.includes('localhost')) {
    baseURL = `http://localhost:8181`
}

const MicRecorder = require('mic-recorder-to-mp3')
 
const recorder = new MicRecorder({
    bitRate: 128
})

let file = null

export default class RecordUtil {

    async startRecording() {
        let responseData
        await recorder.start().then( response => {

            console.log("start -----", response);
            responseData = "start"

        }).catch((e) => {
          console.error(e);
        });

        return responseData
    }
    async stopRecording() {
        let responseData
        await recorder.stop().getMp3().then(([buffer, blob]) => {
            console.log(buffer, blob);
            
            // const file = new File(buffer, 'recorde.mp3', {
            file = new File(buffer, 'recorde.mp3', {    
                type: blob.type,
                lastModified: Date.now()
            });

            console.log("file : ", file)

            // const player = new Audio(URL.createObjectURL(file))
            // player.play();

            responseData = "end"
            
        }).catch((e) => {
            console.error(e)
        })
        
        return responseData
    }
    async saveRecordFile(beforeFileId) {

        console.log("file save : ", file)

        if(beforeFileId == 0){
            beforeFileId = ''
        }
        
        var formData = new FormData();
        formData.append('file', file);
        formData.append('beforeFileId', beforeFileId);

        let responseData
        await axios.post(baseURL + '/user/apis/v1/file/upload',
            formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then( response => {
            responseData = response.data;
        })
        .catch(async error => {
            console.log(error)
        })

        return responseData
    }
}